import { AccountAvatar, styled, UserAvatar } from '@driftt/dds'

export const AccountActivityUserAvatar = styled(UserAvatar, { '& img': { objectFit: 'contain' } })
export const AccountActivityAccountAvatar = styled(AccountAvatar, {
  '& img': { objectFit: 'contain' }
})
